<template>
  <div>
    <v-card-title class="pt-0 primary--text">{{ title }}</v-card-title>
    <v-container>
      <v-row>
        <v-col class="center-otp">
          <OtpInput
            id="otp"
            ref="otpInput"
            :input-classes="$vuetify.theme.dark ? ' otp-input otp-input-dark' : 'otp-input'"
            separator="-"
            :num-inputs="4"
            :should-auto-focus="true"
            :is-input-num="true"
            @on-load="setFocus"
            @on-complete="handleOnComplete"
            @on-change="handleOnChange"
            autofocus
          />
        </v-col>
      </v-row>
    </v-container>

    <v-card-actions>
      <div v-if="showCancelButton" class="t-a-r w-100">
        <v-btn outlined style="width: 80px" class="mr-2" @click="cancelTransfer"
          >Cancel</v-btn
        >
        <v-btn
          color="primary"
          style="width: 80px"
          class="ml-2 mr-2"
          @click="handleOtpInput"
          >Confirm</v-btn
        >
      </div>
      <div v-else class="my-2 f-c w-100">
        <v-btn color="primary" @click="handleOtpInput">Confirm</v-btn>
      </div>
    </v-card-actions>
  </div>
</template>

<script>
import OtpInput from "@bachdgvn/vue-otp-input";

export default {
  components: { OtpInput },
  props: {
    title: {
      type: String,
      default: "Enter Last 4 Digits Of Aadhaar",
    },
    showCancelButton: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    otpEntered: "",
  }),
  methods: {
    setFocus() {
      if (document.getElementById("otp") !== null) {
        document.getElementById("otp").focus();
      }
    },
    handleOnChange(v) {
      this.otpEntered = v;
    },
    handleOnComplete(v) {
      this.$emit("ConfirmOtp", v);
    },
    handleOtpInput() {
      if (this.otpEntered.length == 4) {
        this.$emit("ConfirmOtp", this.otpEntered);
      } else {
        this.$emit("snackbarShow", "Please enter valid OTP", "primary", 5000);
      }
    },
    /*handleClearInput() {
      this.$refs.otpInput.clearInput()
    },*/
    cancelTransfer() {
      this.$emit("cancelTransfer");
    },
  },
};
</script>
<style lang="scss">
.otp-input {
  width: 50px;
  height: 50px;
  padding: 5px;
  margin: 0 10px;
  font-size: 20px;
  border-radius: 4px;
  border: 2px solid !important;
  border-color: var(--secondary-color);
  text-align: center;
  //color: #fff;
  &.error {
    border: 1px solid red !important;
  }
}
.otp-input:focus {
  border: 2px solid !important;
  // border-color: white;
  outline: none !important;
}
.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.center-otp > div {
  justify-content: center !important;
}
.otp-input-dark {
  border-color: #a4a4a4 !important;
}
</style>
